<template>
  <div class="outstandingBill">
    <div class="searchForm">
      <el-date-picker
        v-model="formTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
      <el-button class="search-btn" @click="pageNo = 1 , onSearch()">查询</el-button>
      <el-button class="screen-btn" @click="moreSearch = !moreSearch">
        高级筛选
        <i
          :class="moreSearch ? 'el-icon-arrow-up el-icon--right' : 'el-icon-arrow-down el-icon--right'"
        />
      </el-button>
      <span class="summary">
        <el-tooltip class="item" effect="dark" :content="`订单总数：${sumBillData.FOrderCount} 明细数量：${sumBillData.FCount} 总金额：${FPriceShow ? sumBillData.FAllAmount.toFixed(2) : '价格不可见'} ${!IsMoreDepart ? `所属部门：${IsFDepartName}` : ''}`" placement="top-start">
          <span>
            <span>订单总数：</span><span class="redNum">{{ sumBillData.FOrderCount }}</span>
            <span>明细数量：</span><span class="redNum">{{ sumBillData.FCount }}</span>
            <span>总金额：</span>
            <span v-if="FPriceShow" class="redNum"><span class="smallIden">￥</span>{{ sumBillData.FAllAmount.toFixed(2) }}</span>
            <div v-else id="noShowPrice" style="margin-right:10px;">
              <span>￥</span>价格不可见
            </div>
            <span v-if="!IsMoreDepart">所属部门：</span><span v-if="!IsMoreDepart" class="redNum">{{ IsFDepartName }}</span>
          </span>
        </el-tooltip>
        <el-button class="search-btn export-btn" @click="exportExcel">导出Excel</el-button>
      </span>
      <div v-if="moreSearch" class="moreSearch">
        <el-form ref="form" style="display:flex;" :model="formData" label-width="100px">
          <div>
            <el-form-item label="商品名称:" label-width="80px">
              <el-input v-model="formData.FStockName" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="商品金额:">
              <div style="display:flex;">
                <el-input v-model="formData.FMinAmount" />
                <div style="margin: 0 3px;">
                  -
                </div>
                <el-input v-model="formData.FMaxAmount" />
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="订单编号:">
              <el-input v-model="formData.FOrderNo" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="所属部门:">
              <el-input v-model="formData.FDepartName" clearable @clear="clearDepart">
                <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true)" />
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="订单状态:">
              <el-select v-model="formData.FOrderStatus" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="formTable">
      <el-table
        ref="singleTable"
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        border
        fit
        style="width: 100%"
        height="calc(100% - 72px)"
        :header-cell-style="{background:'#EC212D',color:'#fff',fontSize:'16px',fontWeight:'500',textAlign: 'center'}"
        :cell-style="{ textAlign: 'center',height:'66px',background:'#fff' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          show-overflow-tooltip
        />
        <el-table-column
          property="FOrderDate"
          label="交易日期"
          show-overflow-tooltip
        />
        <el-table-column
          property="FStockName"
          label="商品名称"
          width="300"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="text-align:left;">
              <span style="display: inline-block;width: 35px;">
                <el-image
                  v-if="scope.row.FStockImagePath"
                  style="width: 35px; height: 35px;vertical-align: middle;"
                  :src="scope.row.FStockImagePath || ''"
                  :preview-src-list="[scope.row.FStockImagePath]"
                />
              </span>
              <span class="stockName" @click="toDetail(scope.row)">
                {{ scope.row.FStockName }}
              </span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          property="FQuanty"
          label="数量"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.FQuanty }}
            <span v-if="scope.row.FMeasurement">
              /{{ scope.row.FMeasurement }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column
          property="FTotalPrice"
          label="单价/数量"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- color:#EC212D; -->
            <template>
              <span v-if="FPriceShow" style="font-weight: bold;">
                <span style="font-size:12px;">￥</span>{{ scope.row.FTotalPrice.toFixed(2) }}
              </span>
              <span v-else id="noShowPrice">
                <span style="margin:0;">￥</span>价格不可见
              </span>
              <span style="margin:0 5px;">x</span>
              <span style="font-weight: bold;">{{ scope.row.FQuanty }}</span>
              <span v-if="scope.row.FMeasurement">
                /{{ scope.row.FMeasurement }}
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          property="FReturnQuanty"
          label="商品金额"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- color:#EC212D; -->
            <span v-if="FPriceShow" style="font-weight: bold;">
              <span style="font-size:12px;">￥</span>{{ scope.row.FTotalAmount.toFixed(2) }}
            </span>
            <span v-else id="noShowPrice">
              <span style="margin:0;">￥</span>价格不可见
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="FOrderStatus"
          label="订单状态"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.FOrderStatus == 5 ? '已完成' : scope.row.FOrderStatus == 0 ? '已退货' : '未完成' }}</span>
            <!-- <el-tag v-if="scope.row.FOrderStatus == 4">待收货</el-tag>
            <el-tag v-if="scope.row.FOrderStatus == 5" type="success">已完成</el-tag>
            <el-tag v-if="scope.row.FOrderStatus == 3" type="info">待发货</el-tag>
            <el-tag v-if="scope.row.FOrderStatus == 1" type="warning">待接单</el-tag>
            <el-tag v-if="scope.row.FOrderStatus == 0" type="danger">已退货</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column
          v-if="IsMoreDepart"
          property="FDepartName"
          label="所属部门"
          show-overflow-tooltip
        />
        <el-table-column
          property="FUserName"
          label="下单人"
          sortable
          show-overflow-tooltip
        />
        <el-table-column
          property="FRemark"
          label="明细备注"
          sortable
          show-overflow-tooltip
        />
        <!-- <el-table-column
          width="160"
          property="FOrderDate"
          label="明细日期"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.FOrderDate }}
          </template>
        </el-table-column> -->

      </el-table>
      <el-pagination
        style="text-align: right;margin-top:20px;"
        background
        layout="total , sizes, prev, pager, next , jumper"
        :page-sizes="[50, 100, 500]"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="onSearch"
      />
    </div>
    <tree
      ref="depart"
      title="所属部门"
      label="FName"
      parent-id="FParentID"
      :tree-visible="searchVisible"
      :default-arr="defaultArr"
      search-url="/mall/mallmanage/billapprovalinfo/getDepartInfo"
      @treeConfirm="cfmSearch"
      @treeClose="selectDeparment"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import tree from '@/components/tree/tree.vue'
export default {
  components: {
    tree
  },
  data() {
    return {
      defaultArr: [],
      loading: false,
      searchVisible: false,
      moreSearch: false,
      formTime: [],
      formData: {
        FBeginOrderDate: '',
        FEndOrderDate: '',
        FStockName: '',
        FMinAmount: '',
        FMaxAmount: '',
        FOrderNo: '',
        FTreeCode: '',
        FDepartName: '',
        FOrderStatus: -1
      },
      options: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 0,
          label: '未完成'
        },
        {
          value: 1,
          label: '已完成'
        },
        {
          value: 2,
          label: '已退货'
        }
      ],
      pageNo: 1,
      pageSize: 50,
      total: 0,
      tableData: [],
      excelLoading: null,
      sumBillData: {
        FAllAmount: 0.00,
        FCount: 0,
        FOrderCount: 0
      },
      IsFDepartName: '',
      IsMoreDepart: 0,
      FPriceShow: 0
    }
  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    var date = new Date()
    var dayS = date.getDate()
    var month = parseInt(date.getMonth() + 1)
    if (month < 10) {
      month = '0' + month
    }
    if (dayS < 10) {
      dayS = '0' + dayS
    }
    date.setDate(1)
    this.formTime[0] = date.getFullYear() + '-' + month + '-' + '01'
    this.formTime[1] = date.getFullYear() + '-' + month + '-' + dayS
    this.onSearch()
  },
  methods: {
    getSixMonth() {
      const dt = new Date()
      dt.setMonth(dt.getMonth() - 6)
      //   HH:MM
      return (this.dateFormat('YYYY-mm-dd', new Date(dt.getTime()))).slice(0, 8) + '01'
    },
    dateFormat(fmt, date) {
      let ret
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (const k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        }
      }
      return fmt
    },
    toDetail(item) {
      const routeUrl = this.$router.resolve({
        name: 'MyOrderManagement',
        query: {
          FBillID: item.FBillID
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    exportExcel() {
      this.excelLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      params.append('billType', 0)
      request({
        url: '/mall/demand/userCenter/excel/export/demandBill',
        method: 'post',
        params,
        responseType: 'blob'
      })
        .then(res => {
          if (!res.data.size) {
            this.excelLoading.close()
            this.$message.warning('没有可导出的数据')
            return
          }
          const content = res.data // 文件流
          const blob = new Blob([content], { type: 'application/vdn.ms-excel' })
          const contentDisposition = res.headers['content-disposition']
          const fileName = decodeURI(contentDisposition.split('=')[1])
          if ('download' in document.createElement('a')) { // 非IE下载
            const link = document.createElement('a')
            const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', `${fileName}`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.excelLoading.close()
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
            this.excelLoading.close()
          }
        })
        .catch(() => {
          this.excelLoading.close()
        })
    },
    getFormData() {
      const jsonobj = JSON.parse(JSON.stringify(this.formData))
      if (this.formTime !== null && this.formTime.length) {
        jsonobj.FBeginOrderDate = this.formTime[0]
        jsonobj.FEndOrderDate = this.formTime[1]
      }
      jsonobj.FMinAmount = jsonobj.FMinAmount === '' ? -1 : Number(jsonobj.FMinAmount)
      jsonobj.FMaxAmount = jsonobj.FMaxAmount === '' ? -1 : Number(jsonobj.FMaxAmount)
      delete jsonobj.FDepartName
      return jsonobj
    },
    // /demand/userCenter/sumBill
    getSumBill() {
      const params = new URLSearchParams()
      params.append('billType', 0)
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/sumBill',
        method: 'post',
        params
      })
        .then(res => {
          this.sumBillData = res.data
          this.IsMoreDepart = res.data.IsMoreDepart
          this.IsFDepartName = res.data.IsFDepartName
        })
    },
    onSearch() {
      this.loading = true
      this.getSumBill()
      const params = new URLSearchParams()
      params.append('pageNo', this.pageNo)
      params.append('pageSize', this.pageSize)
      params.append('billType', 0)
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/queryDemandBill',
        method: 'post',
        params
      })
        .then(res => {
        //   this.IsMoreDepart = res.data.IsMoreDepart
        //   this.IsFDepartName = res.data.IsFDepartName
          this.tableData = res.data.PageList.records
          this.total = res.data.PageList.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    cfmSearch(val, arr) {
      this.defaultArr = val ? [val.fid] : ''
      this.formData.FTreeCode = val ? val.FTreeCode : ''
      this.formData.FDepartName = val ? val.FName : ''
      this.searchVisible = false
    },
    clearDepart() {
      this.formData.FTreeCode = this.formData.FDepartName = ''
      this.defaultArr = []
      this.$refs.depart.clear()
    },
    selectDeparment(val) {
      !val && this.$refs.depart.clear()
      this.searchVisible = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    }
  }
}
</script>

<style lang="scss">
.outstandingBill {
    height: calc(100vh - 112px);
    .el-table .sort-caret.ascending {
        border-bottom-color: #fff;
    }
    .el-table .sort-caret.descending {
        border-top-color: #fff;
    }
    .el-table .ascending .sort-caret.ascending {
        border-bottom-color: #C0C4CC;
    }
    .el-table .descending .sort-caret.descending {
        border-top-color: #C0C4CC;
    }
    .searchForm {
        .summary {
            display: flex;
            height: 41px;
            float: right;
            >span {
                height: 41px;
                display: flex;
                align-items: center;
            }
            .redNum {
                min-width: 60px;
                padding-right: 10px;
                color: #EC212D;
                font-size: 24px;
                font-weight: 600;
                height: 28px;
                line-height: 28px;
            }
            .smallIden {
                color: #EC212D;
                font-weight: 600;
                font-size: 12px;
            }
        }
        .search-btn {
            width: 72px;
            height: 40px;
            background: #EC212D;
            color: #fff;
            margin-left: 32px;
        }
        .screen-btn {
            width: 124px;
            height: 41px;
            background: #F5F5F5;
            color: #666666;
            margin-left: 32px;
        }
        .export-btn {
            float: right;
            width: 97px;
        }
        .moreSearch {
            height: 60px;
            background: #F5F5F5;
            margin-top: 10px;
            padding: 10px 0;
            .el-form>div {
                width: 20%;
            }
            .el-form-item__label {
                font-size: 16px;
                color: #8C909C;
                font-weight: 400;
            }
        }
    }
    .formTable {
        margin-top: 10px;
        .stockName {
            cursor: pointer;
            text-decoration: underline;
        }
        .stockName:hover {
            color: #ec212d !important;
        }
    }
}
</style>
